import { render, staticRenderFns } from "./ModalInfoBalance.vue?vue&type=template&id=3b7a3501&"
import script from "./ModalInfoBalance.vue?vue&type=script&lang=js&"
export * from "./ModalInfoBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports